export default "__VITE_ASSET__DW17yHp0__"